import { render, staticRenderFns } from "./authIdCard.vue?vue&type=template&id=0c1b177f&scoped=true"
import script from "./authIdCard.vue?vue&type=script&lang=js"
export * from "./authIdCard.vue?vue&type=script&lang=js"
import style0 from "./authIdCard.vue?vue&type=style&index=0&id=0c1b177f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b177f",
  null
  
)

export default component.exports